/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
// Soft UI Dashboard PRO React icons

import LogoutIcon from "@mui/icons-material/Logout";
import UpgradeIcon from "../components/NavIcons/UpgradeIcon";
import AffiliatesIcon from "../components/NavIcons/AffiliatesIcon";
import WidgetsIcon from "../components/NavIcons/WidgetsIcon";
import DashboardIcon from "../components/NavIcons/DashboardIcon";
import HubIcon from "../components/NavIcons/HubIcon";
import ScorecardIcon from "../components/NavIcons/ScorecardIcon";
import ClaimsIcon from "../components/NavIcons/ClaimsIcon";
import FeedIcon from "../components/NavIcons/FeedIcon";
import ChallengeArenaIcon from "../components/NavIcons/ChallengeArenaIcon";
import MessageIcon from "../components/NavIcons/MessageIcon";
import ScorekeeperIcon from "../components/NavIcons/ScorekeeperIcon";

const sidenavRoutes = [
  {
    type: "collapse",
    name: "My Dashboard",
    key: "home",
    route: "/home",
    icon: <DashboardIcon />,
    noCollapse: true,
  },
  { type: "title", title: "My Game", key: "game-pages" },
  {
    type: "collapse",
    name: "Scorecard",
    key: "scorecard",
    route: `/scorekeeper/timeline?player=true`,
    icon: <ScorekeeperIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Hub",
    key: "hub",
    route: "/hub",
    icon: <HubIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Claims",
    key: "claims",
    route: "/claims",
    icon: <ClaimsIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Level Up",
    key: "levelup",
    route: "/levelup",
    icon: <UpgradeIcon />,
    noCollapse: true,
    primeOnly: true,
  },
  {
    type: "title",
    title: "Activities",
    key: "activity-pages",
    primeOnly: true,
  },
  {
    type: "collapse",
    name: "Feed",
    key: "feed",
    route: "/feed",
    icon: <FeedIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Messages",
    key: "messages",
    route: "/messages",
    icon: <MessageIcon />,
    noCollapse: true,
    primeOnly: true,
  },
  {
    type: "collapse",
    name: "Challenge Arena",
    key: "challenge-arena",
    route: "/challenge-arena",
    icon: <ChallengeArenaIcon />,
    noCollapse: true,
    primeOnly: true,
  },
  {
    type: "collapse",
    name: "Manage Widgets",
    key: "manage-widgets",
    route: "/widgets",
    icon: <WidgetsIcon />,
    noCollapse: true,
    primeOnly: true,
  },
  {
    type: "title",
    title: "System",
    key: "system-pages",
    affiliateOnly: true,
    primeOnly: true,
  },
  {
    type: "collapse",
    name: "Affiliate Hub",
    key: "affiliates",
    route: "/affiliates",
    icon: <AffiliatesIcon />,
    noCollapse: true,
    primeOnly: true,
    affiliateOnly: true,
  },
];

export default sidenavRoutes;
